export const displayGroups = [
    { id: 1, name: 'Paired Exchange', prefix: 'pe', class: 'paired-exchange', order: 1 },
    { id: 10, name: 'Kidney For Life', prefix: 'kfl', class: 'kfl', order: 1.5 },
    { id: 2, name: 'Voucher Donation', prefix: 'ad', class: 'advanced-donation', order: 3 },
    { id: 3, name: 'Automated Workflow', prefix: 'aw', class: 'automated-workflow', order: 4 },
    { id: 4, name: 'Donor Search', prefix: 'ds', class: 'donor-search', order: 6 },
    { id: 6, name: 'Referrals', prefix: 'ref', class: 'referrals', order: 7 },
    { id: 7, name: 'Partner Center', prefix: 'pc', class: 'partner-center', order: 2 },
    //{ id: 8, name: 'Billing', prefix: 'bill', class: 'billing', order: 8 }, // no columns match this group
    { id: 9, name: 'Serologies', prefix: 'sero', class: 'serologies', order: 5 },
    { id: 5, name: 'Other', prefix: 'other', class: 'other', order: 9 }
];